import {
  DomainAlgebra,
  DomainFinance,
  DomainFunctions,
  DomainGeometry,
  DomainMeasGeom,
  DomainMeasure,
  DomainNumBase10,
  DomainNumFracs,
  DomainNumber,
  DomainOperations,
  DomainPatterns,
  DomainRatioProp,
  DomainShapeSpace,
  DomainStatsProb,
  DomainStats,
  DomainExpressions,
  DomainNumAlgebra,
  DomainDefault
} from '../../helpers/icon-dictionary';

export const DEFAULT_STUDENT_ID = -1;

export const getQuestion = (girlId, courses) => {
  let question;
  if (courses.topics) {
    courses.topics[0].childTopics.some((topic) => {
      question = topic.childTopics.find(q => q.id === girlId);
      return question;
    });
  }
  return question || {};
};

export const getDomainIcon = (domain) => {
  switch (domain) {
    case 'Measurement and Geometry':
    case 'Geometry and Measurement':
      return DomainMeasGeom;

    case 'Number and Algebra':
    case 'Numbers and Algebra':
      return DomainNumAlgebra;

    case 'Statistics and Probability':
    case 'Statistics & Probability':
    case 'Probability':
      return DomainStatsProb;

    case 'Measurement':
    case 'Measurement & Data':
      return DomainMeasure;

    case 'Number':
    case 'The Number System':
      return DomainNumber;

    case 'Algebra':
      return DomainAlgebra;

    case 'Statistics':
    case 'Data':
      return DomainStats;

    case 'Ratio and Proportion':
    case 'Ratio & Proportional Relationships':
      return DomainRatioProp;

    case 'Geometry':
      return DomainGeometry;

    case 'Patterns and Relations':
      return DomainPatterns;

    case 'Shape and Space':
    case 'Spatial Sense':
      return DomainShapeSpace;

    case 'Finatial Literacy':
      return DomainFinance;

    case 'Operations & Algebraic Thinking':
      return DomainOperations;

    case 'Number & Operations in Base Ten':
      return DomainNumBase10;

    case 'Number & Operations - Fractions':
      return DomainNumFracs;

    case 'Expressions & Equations':
      return DomainExpressions;

    case 'Functions':
      return DomainFunctions;

    default: return DomainDefault;
  }
};

export const getDomainFromStrand = (strand) => {
  switch (strand) {
    case 'MNA':
      return 'Numbers and Algebra';
    case 'MME':
      return 'Measurement';
    case 'MGE':
      return 'Geometry';
    case 'MST':
      return 'Statistics';
    case 'MPR':
      return 'Probability';
    default:
      return null;
  }
};
